'use client';

import HomeTitle from '@/components/home/home-title';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Grid } from 'swiper/modules';
import { BrandCard } from '../cards';
import { useState } from 'react';

const BrandsSlider = ({ data, locale, isMobile, brands }) => {
  const [swiper, set_swiper] = useState(null);
  return (
    <div
      className={`rounded-lg bg-white px-2.5 sm:px-3 md:px-3.5 lg:px-4 ${!swiper && 'overflow-hidden'}`}
    >
      <HomeTitle
        title={data?.[`title-${locale}`]}
        link='#'
        swiper={swiper}
        linkTitle={locale === 'en' ? 'Show All' : 'عرض الكل'}
        parentClassName='pt-2 pb-[5px] sm:pt-2.5 sm:pb-1.5 md:py-3 lg:py-3.5'
        linkClassName='underline'
      />
      <div className='max-md:border-t-border flex-1 max-lg:pt-2 max-md:border-t max-sm:pb-2'>
        <Swiper
          onInit={(e) => set_swiper(e)}
          modules={[Grid]}
          spaceBetween={10}
          breakpoints={{
            320: { spaceBetween: 10, slidesPerView: 2.25 },
            480: { spaceBetween: 10, slidesPerView: 3 },
            768: { spaceBetween: 12, slidesPerView: 4 },
            1024: { spaceBetween: 14, slidesPerView: 4 },
            1280: { spaceBetween: 14, slidesPerView: 5 },
          }}
          grid={{ fill: 'row', rows: 2 }}
          // slidesPerView='auto'
          loop={brands?.length > 3}
        >
          {(swiper ? brands : brands.slice(0, 10))?.map(
            (info, index) =>
              (isMobile ? info?.['mobile-active'] : info?.active) && (
                <SwiperSlide key={index}>
                  <BrandCard
                    target={info?.['open-in-new-tab'] ? '_blank' : '_self'}
                    url={`/b/${info?.url}`}
                    img={info?.['img-ar']}
                    name={info?.alt ?? info?.[`title-${locale}`]}
                  />
                </SwiperSlide>
              )
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default BrandsSlider;
